import { useState } from "react";
import { IoCheckmarkDoneSharp, IoCloseSharp } from "react-icons/io5";
import ImgBellNotificationAdmin from "src/assets/images/bellnotification.gif";

import SkeletonGeneralCard from "../Shared/Skeletons/SkeletonGeneralCard";
import { classNames, dateToLocal, dateToLocalHour, getHourDate } from "src/helpers/mixins";
import { useNavigate } from "react-router-dom";
import { useAppStateContext } from "src/auth/AppStateContext";
import APIService from "src/services/Api";
import { ImSpinner9 } from "react-icons/im";
import { Tooltip } from "antd";

type ParamsNotiUB = {
  close(): void;
};
type TypeLoadingDel = {
  id: number | string
  loading: boolean
}
const NotificationAdminBody: React.FC<ParamsNotiUB> = ({ close }) => {
  const navigate = useNavigate();
  const [animateClose, setAnimateClose] = useState<boolean>(false);
  const [loadingDel, setLoadingDel] = useState<TypeLoadingDel>({id:'',loading:false})
  const [animationDelete, setAnimationDelete] = useState<string|number>('-')
  const { adminNotifications } = useAppStateContext();
 
  const handleClose = () => {
    setAnimateClose(true);
    window.setTimeout(() => {
      close();
    }, 500);
  };

  const handleNavigate = (link: string) => {
    navigate(link);
    handleClose();
  };

/*   const markAsRead = async(id:any) => {
    await APIService.adminNotificationRead({id})
  }
 */
  const handleRemove = async(id:string|number) => {
    setLoadingDel({id,loading: true})
    const del = await APIService.adminNotificationDelete({id})
    if(del.data.data.del.affected === 1 ){
      setAnimationDelete(id)
    }else{
      alert('no fue posible eliminar')
    }
    setLoadingDel({id,loading: false})
  }
 
  return (
    <div>
      <div className="sidebar-notification-user opensans">
        <div
          className={classNames(
            "opacity-before",
            animateClose ? "fadeout" : "fadein"
          )}
        ></div>
        <div
          className={classNames(
            `content-notification-user bg-stone-100`,
            animateClose ? `forwardleft` : `forwardright`
          )}
        >
          <div className="bg-white text-base font-normal flex items-center justify-between py-4 px-4 shadow-md">
            <div className="flex items-center gap-2 fadeintop">
              <img
                src={ImgBellNotificationAdmin}
                className="w-14"
                alt="Notificacion"
              />
              Notificaciones Admin 

              <Tooltip title="Salir">

                <IoCloseSharp
                onClick={() => handleClose()}
                className="cursor-pointer"
                size={33}
              />
              </Tooltip>
            </div>

          </div>
          <div className="px-4 py-2">
            <SkeletonGeneralCard
              loading={false}
              heightClass={"h-52"}
              arrayItems={8}
              mtClass="mt-0"
              className={"grid grid-cols-1 gap-4"}
            >
              <section className="overflow-y-auto" style={{ maxHeight: "85vh" }}>
                {adminNotifications.length === 0 && (
                  <div className="bg-white rounded-md shadow-sm px-4 py-2 notification-minicard fadeinbottom mb-3">
                    <div className="noti-minc-header  text-stone-700">
                      Actualmente no hay notificaciones pendientes
                    </div>
                    <div className="text-sm" style={{ lineHeight: "24px" }}>
                      Cuando haya algún movimiento en tus transacciones,
                      intercambios o compras te avisaremos inmediatamente.
                    </div>
                  </div>
                )}
                {adminNotifications.map((n, key) => (
                  <div
                    key={key.toString()}
                    className={classNames( animationDelete === n.id ? "fadeout": "", n.seen ? '':'border border-sky-300 ',  " bg-white rounded-md w-full pt-2 notification-minicard mb-4 border px-2 border-stone-200 text-sm")}>
                      <div className="flex items-center gap-4">
                        <div className="text-xs ">
                          {dateToLocal(new Date()) !==
                           dateToLocal(n.createdAt)
                             ? (
                            <>
                              {dateToLocal(n.createdAt)}{" "}
                            </>
                          ) : (
                            <span className={classNames( n.seen ? "bg-transparent " : "bg-yellow-400","px-1 py-1 rounded-md")}>Hoy</span>
                          )}
                          <span className="text-xs font-normal">
                            {" "}
                            {dateToLocalHour(n.createdAt)}
                          </span>
                        </div>
                        {n.seen &&
                          <IoCheckmarkDoneSharp size={17} className="text-sky-500" />
                        }
                      </div>

                      <div className="noti-minc-header pt-2 text-stone-700">
                      <span dangerouslySetInnerHTML={{ __html: n.message }} />
                    </div>

                    <div className="flex items-center  mb-2 gap-4 mt-2">
                      {(n?.link?.length || 0 ) > 0 &&
                        <button
                          onClick={() => handleNavigate(n.link)}
                          className="bg-stone-200 px-1 cursor-pointer text-black rounded-sm py-1 text-xs"
                        >
                          Leer Más
                        </button>
                      
                      }
             
                      <div onClick={() => (loadingDel.id === n.id && loadingDel.loading ? undefined : handleRemove(n.id))} 
                        className="bg-stone-200 px-1 cursor-pointer text-black rounded-sm py-1 text-xs">
                        {(loadingDel.id === n.id && loadingDel.loading) ? 
                        <div className="flex items-center gap-2">
                          Cargando.. <ImSpinner9 className="text-rose-400 animate-spin"/>
                        </div>
                        :
                        'Eliminar'
                        }
                      </div>
                    </div>
                  </div>
                ))}
                <div className="w-full mb-52"></div>
              </section>
            </SkeletonGeneralCard>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationAdminBody;
